<div class="map-container">
    <app-map></app-map>
</div>

